// Company-wide project gross margin bands per fiscal year (Admin > Project Margin Targets).
//   margin >= minimumMargin                  -> Good (green)
//   warningMargin <= margin < minimumMargin  -> Warning (yellow)
//   margin < warningMargin                   -> Critical (red)

export interface MarginBands {
    minimumMargin: number
    warningMargin: number
    idealMargin: number
}

// Row in Admin > Project Margin Targets
export interface ProjectMarginTarget extends MarginBands {
    id: string
    fiscalYear: number
    updatedBy: string | null
    updatedAt: string
}

// Bands in effect for a fiscal year; source DEFAULT = no row for that year, Project Health rules used
export interface EffectiveMarginTarget extends MarginBands {
    fiscalYear: number
    source: "FY" | "DEFAULT"
}

// Used only until the fiscal year's target has loaded (same values as the GM_* health rule defaults)
export const FALLBACK_MARGIN_BANDS: MarginBands = { minimumMargin: 40, warningMargin: 30, idealMargin: 45 }
